module.exports = __webpack_public_path__ + "img/favsi.2805f486.png";